import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=33731b6e&scoped=true&"
import script from "./ListCard.vue?vue&type=script&lang=js&"
export * from "./ListCard.vue?vue&type=script&lang=js&"
import style0 from "./ListCard.vue?vue&type=style&index=0&id=33731b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33731b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
